import { render, staticRenderFns } from "./budget-sum-calc.vue?vue&type=template&id=781f1d4f&"
import script from "./budget-sum-calc.vue?vue&type=script&lang=ts&"
export * from "./budget-sum-calc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports